<template>
    <b-container fluid>
        <b-row>
        <b-col lg="12" sm="12">
            <b-row>
                <b-col  v-if="loading" lg="12" sm="12" class="form-for-textarea">
                    <h4 class="text-center">{{ $t('externalUser.loading') }} .....</h4>
                </b-col>
                <b-col v-else lg="12" sm="12" class="form-for-textarea" style="border:1px solid gray">
                    <div class="row mt-4">
                        <div class="col-md-8">
                            <p style="font-size:16px;color:black;font-weight:bold" class="p-0 m-0">{{ $t('externalUser.payment_recept') }}</p>
                        </div>
                        <div class="col-md-4 text-dark">
                            <table>
                                <tr>
                                    <td>{{ $t('externalUser.production.receive_id') }}</td>
                                    <td>: {{ formData.delivery_rec_main.receive_id }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('retailerManagement.receive_date') }}</td>
                                    <td>: {{ formData.delivery_rec_main.receive_date | dateFormat }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-md-12 text-dark">
                            <table>
                                <tr>
                                    <td>{{ $t('sales_center.total_amount') }} </td>
                                    <td>: {{ formData.amount }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('externalUser.transaction_no') }}</td>
                                    <td>: {{ formData.transaction_no }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('externalUser.payment_date') }}</td>
                                    <td>: {{ formData.created_at | dateFormat }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('externalUser.voucher_no') }}</td>
                                    <td>: {{ formData.voucher_no }}</td>
                                </tr>
                                <tr>
                                    <td>{{ $t('externalUser.payment_type') }}</td>
                                    <td>: <span class="badge badge-success">{{ getPaymentTypeName(formData.payment_type_id) }}</span></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <p style="font-size:16px;color:black;font-weight:bold" class="mt-3 p-0 m-0"><u>{{ $t('externalUser.product_list') }}</u></p>
                    <b-table-simple striped bordered small>
                        <b-tr>
                            <b-th>{{ $t('globalTrans.sl_no') }}</b-th>
                            <b-th>{{ $t('retailerManagement.product_name') }}</b-th>
                            <b-th>{{ $t('retailerManagement.unit') }}</b-th>
                            <!-- <b-th>{{ $t('retailerManagement.quantity') }}</b-th> -->
                            <b-th>{{ $t('retailerManagement.receive_quantity') }}</b-th>
                            <b-th>{{ $t('retailerManagement.unit_price') }}</b-th>
                            <b-th>{{ $t('retailerManagement.total_price') }}</b-th>
                        </b-tr>
                        <b-tr v-for="(item, index) in formData.delivery_rec_main.details" :key="index">
                            <b-td>{{ $n(index + 1) }}</b-td>
                            <b-td>{{ productNameById(item.product_id) }}</b-td>
                            <b-td>{{ getStoreData('productUnitList', item.unit_id) }}</b-td>
                            <!-- <b-td>{{ $n(item.quantity) }}</b-td> -->
                            <b-td>{{ $n(item.receive_quantity) }}</b-td>
                            <b-td>{{ $n(item.unit_price) }}</b-td>
                            <b-td>{{ $n(item.total_price) }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-td colspan="5">
                                <span style="margin-left:85%">{{ $t('sales_center.grand_total') }}</span>
                            </b-td>
                            <td>{{ $n(formData.delivery_rec_main.total_amount) }}</td>
                        </b-tr>
                        <b-tr v-if="formData.delivery_rec_main.due_amount > 0">
                            <b-td colspan="4">
                                <span style="margin-left:85%">{{ $t('externalUser.due_amount') }}</span>
                            </b-td>
                            <td>{{ $n(formData.delivery_rec_main.due_amount) }}</td>
                        </b-tr>
                    </b-table-simple>
                    <p style="font-size:16px;color:black;font-weight:bold" class="mt-3 p-0 m-0"><u>{{ $t('sales_distribution_admin.dealer_retailer') + ' ' + $t('globalTrans.details') }}</u></p>
                    <table  class="table table-bordered table-sm" width="50%">
                        <tr>
                            <td width="25%">
                                {{$t('retailerManagement.registration_type')}}
                            </td>
                            <td>: {{ getCommonStoreData('registrationTypeList', formData.user.type) }}</td>
                        </tr>
                        <tr>
                            <td width="25%">
                                {{$t('sales_distribution_admin.dealer_retailer_name')}}
                            </td>
                            <td>: {{ $i18n ? formData.user.name_bn : formData.user.name_en }}</td>
                        </tr>
                        <tr>
                            <td>
                                {{$t('sales_distribution_admin.contact_no')}}
                            </td>
                            <td>: {{ $i18n ? '০' : '0' }}{{ $n(formData.user.contact_no, { useGrouping: false }) }}</td>
                        </tr>
                        <tr>
                            <td>
                                {{$t('retailerManagement.email')}}
                            </td>
                            <td>: {{ formData.user.email }}</td>
                        </tr>
                        <tr>
                            <td width="25%">
                                {{$t('retailerManagement.nid')}}
                            </td>
                            <td>: {{ $n(formData.user.nid, { useGrouping: false }) }}</td>
                        </tr>
                    </table>
                    <div v-if="formData.payment_type_id === 2" class="col-md-12 p-0 m-0 pb-4">
                        <p style="font-size:16px;color:black;font-weight:bold" class="mt-3 p-0 m-0"><u>{{ $t('committee.document') }} : </u></p>
                        <b-img style='height:300px; width:80%' fluid :src="baseUrl + 'download-attachment?file=uploads/security_payment/original/' + formData.voucher"  alt="Right image"></b-img>
                    </div>
                </b-col>
                <div class="col text-right mt-4">
                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-detail')">{{ $t('globalTrans.close') }}</b-button>
                </div>
            </b-row>
        </b-col>
        </b-row>
      </b-container>
</template>
<style>
.form-for-textarea textarea{ line-height: 18px !important;height: 54px !important; }
</style>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { PaymentShow } from '../../../api/routes'
export default {
  props: ['id'],
  created () {
    if (this.id) {
      this.getagentData()
    }
  },
  mounted () {
    core.index()
  },
  data () {
    return {
      formData: '',
      loading: false,
      baseUrl: productionServiceBaseUrl
    }
  },
  computed: {
  },
  methods: {
    getDueAmount () {
       return this.formData.delivery_rec_main.total_amount - this.formData.amount
    },
    getagentData () {
        this.loading = true
        RestApi.getData(productionServiceBaseUrl, PaymentShow + `/${this.id}`).then(response => {
            if (response.success) {
                const tmpData = response.data
                if (tmpData.is_pertial) {
                    const newData = tmpData.delivery_rec_main.details.filter(item => item.product_id === tmpData.product_id)
                    const dd = Object.assign(tmpData.delivery_rec_main, { details: newData })
                    this.formData = Object.assign(tmpData, { delivery_rec_main: dd })
                } else {
                    this.formData = tmpData
                }
            }
            this.loading = false
        })
    },
    getGrandTotal () {
      const result = this.formData.delivery_rec_main.details.reduce((total, item) => total + parseFloat(item.total_price), 0)
      const total = parseFloat(result)
      return total
    },
    productNameById (id) {
        const product = this.$store.state.ExternalUser.productionCommonObj.productList.find(product => product.value === id)
        if (typeof product === 'undefined') {
            return ''
        } else {
            if (this.$i18n.locale === 'bn') {
                return product.text_bn
            } else {
                return product.text_en
            }
        }
    },
    getPaymentTypeName (Id) {
        const Obj = this.$store.state.ExternalUser.commonObj.paymentTypeList.find(item => item.value === parseInt(Id))
        if (this.$i18n.locale === 'bn') {
            return Obj.text_bn
        } else {
            return Obj.text_en
        }
    },
    getStoreData (state, Id) {
      if (state) {
        const tmpData = this.$store.state.ExternalUser.productionCommonObj[state]
        if (typeof tmpData === 'undefined') {
          return ''
        } else {
          const data = tmpData.find(item => item.value === Id)
          if (typeof data === 'undefined') {
            return ''
          } else {
            return this.$i18n ? data.text_bn : data.text_en
          }
        }
      }
    },
    getCommonStoreData (state, Id) {
      if (state) {
        const tmpData = this.$store.state.ProductionService.commonObj[state]
        if (typeof tmpData === 'undefined') {
          return ''
        } else {
          const data = tmpData.find(item => item.value === Id)
          if (typeof data === 'undefined') {
            return ''
          } else {
            return this.$i18n ? data.text_bn : data.text_en
          }
        }
      }
    }
  }
}
</script>
